

import React, { useRef, useState, useEffect } from 'react';
import { Container, Row, Col, FormGroup, Label, Input } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import ViewTransaction from './../transactions/view-beta-txn';
import { FaRegMoneyBillAlt } from 'react-icons/fa';
import {
  getMailTemplates,
  inWords,
  getAllLetterTemplates,
  SendMailTo,
} from './../../stores/services/template.service';
import { getAllPendingTransactions, getLedger, searchTransactions } from '../../stores/services/transactions.service';
import { getAmc } from '../../stores/services/amc.service';
import { getFundByAmc } from '../../stores/services/funds.service';
import jsPDF from 'jspdf';
import { useHistory } from 'react-router-dom';
import { RiContactsBookLine, RiMailSendFill } from 'react-icons/ri';
import { BsFileRichtext } from 'react-icons/bs';
import { BsTable } from 'react-icons/bs';
import { getAllBanks } from '../../stores/services/bank.service';
import { toast, ToastContainer } from 'react-toastify';

import { ReceiveOfFundRTGSEmailTemplate } from '../letterTemplates/inflowRTGS.letter.template';
import { OnlineTransferOfFundLetter } from '../letterTemplates/onlineTF.letter.template';
import { TransferOfFundRTGSEmailTemplate } from '../letterTemplates/outflowRTGS.letter.template';
import { demandDraftLetterTemplate } from '../letterTemplates/demandDraft.letter.template';
import { MoneyMarketPurchaseLetter } from '../letterTemplates/mmPurcahse.letter.template';
import { mmMaturityOfSecurityLetter } from '../letterTemplates/mmMaturityOfSecurity.letter.template';
import { mmMaturityOfCouponLetter } from '../letterTemplates/mmMaturityOfCoupon.letter.template';
import { MoneyMarketSaleLetter } from '../letterTemplates/mmSale.letter.template';
import { equityInvestmentLetter } from '../letterTemplates/equityInvestment.letter.template';
import { transferInFundRTGSEmailTemplate } from '../letterTemplates/transferIn.letter.template';
import createDOMPurify from 'dompurify';
import ReactExport from "react-export-excel";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import LetterFooter from '../letterTemplates/letter-footer';
import { AiFillCloseCircle, AiOutlineClose } from 'react-icons/ai';
import { GrClose } from 'react-icons/gr';
import { IoMdClose } from 'react-icons/io';
import { isNumber } from '../../utils/customFunction';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const DOMPurify = createDOMPurify(window);

const PendingTransactions = () => {
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const history = useHistory();
  let [transactions, setTransactions] = useState<any>([]);
  let [status, setStatus] = useState('-1');
  let [searchValue, setSearchValue] = useState('');
  let [activePage, setActivePage] = useState('');
  let [paginationArr, setPaginationArr] = useState(['']);
  let txnTypes = JSON.parse(sessionStorage.getItem('txnType') || '');
  const email = sessionStorage.getItem('email') || '';
  const role = sessionStorage.getItem('role') || '';
  const [allLetterTemplates, setAllLetterTemplates] = useState<any>([]);
  const [letterLoading, setLetterLoading] = useState(false);
  const [tempLoading, setTempLoading] = useState(false);

  const [mailModelBoolean, setMailModelBoolean] = useState(false);
  const [mailTempLoading, setMailTempLoading] = useState(false);
  const [mailTempData, setMailTempData] = useState<any>([]);

  const [chooseTemplate, setChooseTemplate] = useState('');
  const [securityData, setSecurityData] = useState<any>([]);
  const [transType, setTransType] = useState<any>([]);
  const [transMode, setTransMode] = useState<any>([]);
  const [mmCoupon, setMMCoupon] = useState<any>([]);
  const [amtWords, setAmtWords] = useState<any>([]);
  const [grossAmtWords, setGrossAmtWords] = useState<any>([]);
  const [transNetAmount, setTransNetAmount] = useState<any>([]);
  const [transGrossAmount, setTransGrossAmount] = useState<any>([]);
  const [paymentType, setPaymentType] = useState<any>('');
  const [mmType, setMMType] = useState<any>([]);
  const [ledgerData, setLedgerData] = useState<any>([]);


  const [resLoading, setResLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [clearLoading, setClearLoading] = useState(false);
  const [counter, setCounter] = useState('0');


  const [Amc, setAmc] = useState('');
  const [allAmc, setAllAmc] = useState<any>([]);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [fund, setFund] = useState('');

  const [togglePagination, setTogglePagination] = useState(false);

  const [bankData, setBankData] = useState<any>([]);

  const [color, setColor] = useState("#db6cfa");
  const styles = {
    color: color
  }


  React.useEffect(() => {
    const fetchBank = async () => {
      try {
        const bankResponse = await getAllBanks(email);
        setBankData(bankResponse.data.data);
      } catch (error) {
      }
    };
    fetchBank();
  }, []);

  React.useEffect(() => {
    async function getTransactions() {
      if (togglePagination != true) {
        setResLoading(true);
        await getAllPendingTransactions(
          '',
          sessionStorage.getItem('email') || '',
          status === '-1' ? '' : status,
          searchValue,
          activePage
          // sessionStorage.getItem('email') || '',	
          // status,	
          // searchValue,	
          // '',	
          // activePage
        )
          .then((response) => {
            if (response.data.status === 200) {
              let pageArr = paginationArr;
              let existingPageIndex = paginationArr.findIndex(
                (x) => x === response.data.page_info.next_page_number
              );
              if (
                existingPageIndex === -1 &&
                response.data.data.length === 10
                // &&	
                // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)	
              ) {
                pageArr.push(response.data.page_info.next_page_number);
              }
              setPaginationArr(pageArr);
              setTransactions(response.data.data);
              setResLoading(false);
            } else if (response.data.status === 404) {
              toast.error(response.data.message);
              setTransactions([]);
              setResLoading(false);
            }
          })
          .catch((err) => {
            setResLoading(false);
          });
        setResLoading(false);
      } else { // if search is enable
        setResLoading(true);
        if (searchValue !== '') {
          searchValue = 'TXN_' + searchValue;
        }
        await searchTransactions(
          sessionStorage.getItem('email') || '',
          Amc,
          fund,
          status === '-1' ? '' : status,
          searchValue,
          activePage
        )
          .then((response) => {

            if (response.data.data.length > 0) {
              let pageArr = paginationArr
              let existingPageIndex = paginationArr.findIndex(
                (x) => x === response.data.page_info.next_page_number
              );
              if (
                existingPageIndex === -1 &&
                response.data.data.length === 10
                // &&	
                // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)	
              ) {
                pageArr.push(response.data.page_info.next_page_number);
              }
              setPaginationArr(pageArr);
              setTransactions(response.data.data);
            } else {
              setTransactions([]);
            }
            setResLoading(false);

          })
          .catch((err) => {
            setResLoading(false);
          });
        setResLoading(false);

      }
    }
    getTransactions();
  }, [activePage]);

  useEffect(() => {
    const fetchMailTemp = async () => {
      try {
        const response = await getMailTemplates();
        setMailTempData(response.data.template);
        if (response.data.template.length < 1) {
          setMailTempLoading(true);
        } else {
          setMailTempLoading(false);
        }
      } catch (error) { }
    };
    fetchMailTemp();
  }, []);

  const getLetterTemplateCall = async (bankName) => {
    try {
      const response = await getAllLetterTemplates(email, bankName);
      setAllLetterTemplates(response.data.data);
      if (response.data.data.length < 1) {
        setLetterLoading(true);
      } else {
        setLetterLoading(false);
      }
    } catch (error) { }
  };

  //render dropdown for mail data
  const renderMailTemplateDropdown = () => {
    return mailTempData.map((item: any, index: string) => {
      return (
        <option key={index} value={item.value}>
          {item.name}
        </option>
      );
    });
  };


  //render dropdown for security data	
  const renderLetterTemplateDropdown = () => {
    return allLetterTemplates.map((item: any, index: string) => {
      return (
        <option key={index} value={item.template_detail}>
          {item.template_name}
        </option>
      );
    });
  };

  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }
    return txType;
  };

  const bankName = (bankcode) => {
    const bankdata = bankData.filter((item: any, index: string) => {
      return (item.bank_code.replace('BANK_', '') === bankcode);
    });
    if (bankdata.length > 0) {
      return bankdata[0].bank_name;
    }
    else {
      return bankcode;
    }
  }

  useEffect(() => {
    const getAMC = async () => {
      try {
        const amcResponse = await getAmc(email, '', '', '');
        setAllAmc(amcResponse.data.data);
      } catch (err: any) {
        if (err.response !== undefined) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Request Failed!")
        }
      }
    }
    getAMC();
  }, [])

  const renderAmcDropdown = () => {
    return allAmc.map((item: any, index: string) => {
      return (
        <option key={index} value={item.amc_code.replace('AMC_', '')}>
          {item.name}
        </option>
      );
    });
  }

  const getFunds = async (code: any) => {
    try {
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(email, code);
      setAllFunds(response.data.data);
    } catch (error) {

    }
  }

  // Fund Type Drop Down
  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index) => {
      return (
        // <option style={{width: 'auto'}} key={index} value={item.symbol_code}>
        <option key={index} value={item.symbol_code}>
          {item.fund_name} - {item.symbol_code}
        </option>
      );
    })
  }



  const searchTransactionsByAMCAndFund = async (statusVar = '', searchVar = '', amcCodeVar = '', fundCodeVar = '') => {
    setTogglePagination(true);
    return new Promise(async (resolve, reject) => {
      if (searchVar !== '') {
        searchVar = 'TXN_' + searchVar;
      }

      setResLoading(true);
      setSearchLoading(true);
      await searchTransactions(
        sessionStorage.getItem('email') || '',
        amcCodeVar,
        fundCodeVar,
        statusVar === '-1' ? '' : statusVar,
        searchVar,
        activePage
      )
        .then((response) => {
          if (response.data.data.length > 0) {
            // let pageArr = paginationArr

            paginationArr = paginationArr.filter(function (item) {
              return item == ''
            })
            let pageArr = paginationArr;
            let existingPageIndex = paginationArr.findIndex(
              (x) => x === response.data.page_info.next_page_number
            );
            if (
              existingPageIndex === -1 &&
              response.data.data.length === 10
              // &&	
              // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)	
            ) {
              pageArr.push(response.data.page_info.next_page_number);
            }
            setPaginationArr(pageArr);
            setTransactions(response.data.data);
          } else {
            setTransactions([]);
          }
          setResLoading(false);
          setSearchLoading(false);

          resolve('Success');

        })
        .catch((err) => {
          setResLoading(false);
          setSearchLoading(false);
          reject('Error');
        });
      setResLoading(false);
      setSearchLoading(false);
    });
  };

  const clearFilters = async (statusVar = '', searchVar = '') => {
    return new Promise(async (resolve, reject) => {
      setResLoading(true);
      setClearLoading(true);
      await getAllPendingTransactions(
        '',
        sessionStorage.getItem('email') || '',
        statusVar === '-1' ? '' : statusVar,
        searchValue,
        activePage
        // sessionStorage.getItem('email') || '',	
        // statusVar === '-1' ? '' : statusVar,	
        // searchVar,	
        // '',	
        // activePage	
      )
        .then((response) => {
          if (response.data.status === 200) {
            let pageArr = paginationArr;
            let existingPageIndex = paginationArr.findIndex(
              (x) => x === response.data.page_info.next_page_number
            );
            if (response.data.data.length !== 10) {
              if (
                existingPageIndex === -1 &&
                response.data.data.length === 10
              ) {
                pageArr.push(response.data.page_info.next_page_number);
              }
            }
            setPaginationArr(pageArr);
            setTransactions(response.data.data);
            setResLoading(false);
            setClearLoading(false);
            resolve('Success');
            setTogglePagination(false); // false search pagination.
          } else if (response.data.status === 404) {
            toast.error(response.data.message);
            setTransactions([]);
            setResLoading(false);
            setClearLoading(false);
            setTogglePagination(false); // false search pagination.
          }
        })
        .catch((err) => {
          setResLoading(false);
          setClearLoading(false);
          reject('Error');
        });
      setResLoading(false);
      setClearLoading(false);
      setTogglePagination(true);
    });
  };
  const [setLoading] = useState(false);
  const [view, setView] = useState(false);
  const [data, setData] = useState<any>([]);
  const titleCase = (value: string) => {
    let sentence = value.toLowerCase().split('_');
    for (let i = 0; i < sentence.length; i++) {
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    return sentence.join(' ');
  };

  const [trx_history, setTrxHistory] = useState([]);

  const renderPsxData = () => {
    return securites.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.type}</td>
          <td>{items.market}</td>
          <td>{items.symbol}</td>
          <td>{items.quantity}</td>
          <td>{items.avg_rate}</td>
          <td>{items.gross_amount}</td>
          <td>{items.deductions}</td>
          <td>{items.additions}</td>
          <td>{items.net_amount}</td>
        </tr>
      );
    });
  };
  const [flagForSecutities, setFlagForSecutities] = useState(false);
  const [securites, setSecurites] = useState<any>([]);
  const renderSecuritiesModalPopup = () => {
    switch (flagForSecutities) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            onHide={() => { setFlagForSecutities(false) }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setFlagForSecutities(false);
                  // clearTaxobject();	
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">   View Security</h6>
            </div>
            <div className="modal-body">
              <div className="">
                {securites.length > 0 && (
                  <div className="input-size-pos">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Market</th>
                          <th>Symbol</th>
                          <th>Quantity</th>
                          <th>Avg Rate</th>
                          <th>Gross Amount</th>
                          <th>Deduction</th>
                          <th>Addition</th>
                          <th>Net Amount</th>
                        </tr>
                      </thead>
                      <tbody >
                        {renderPsxData()}
                      </tbody>
                    </table>
                  </div>)}
              </div>
            </div>
          </Modal>
        );
      default:
        return '';
    }
  };
  //render table data for tax	
  //view tax table	
  const [viewTaxModal, setTaxModal] = useState(false);
  const [totalTax, setTotalTax] = useState<any>([]);
  //render Tax table data	
  const renderTaxData = () => {
    return totalTax.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.name}</td>
          <td>{items.amount}</td>
          <td>{items.calculatedAmount}</td>
        </tr>
      );
    });
  };
  const renderTaxPopup = () => {
    switch (viewTaxModal) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            onHide={() => { setTaxModal(false) }}
          >

            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setTaxModal(false);
                  // clearTaxobject();	
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up"> View Txn Charges  </h6>
            </div>
            <div className="modal-body">
              <div className="">
                {totalTax.length > 0 && (
                  <div className="input-size-pos">
                    <table className="table my-table">
                      <thead>
                        <tr>
                          <th>Tax Name</th>
                          <th>Tax Amount</th>
                          <th>Calculated Amount</th>
                        </tr>
                      </thead>
                      <tbody >
                        {renderTaxData()}
                      </tbody>
                    </table>
                  </div>)}
              </div>
            </div>
          </Modal>
        );
      default:
        return '';
    }
  };
  const renderData = () => {
    return data.map((value: any, index: number) => {
      return (
        <>
          {value[0] !== 'txn_history' &&
            value[0] !== 'file' &&
            value[1] !== '' &&
            value[1] !== 0 ? (
            <Col md="6" key={index}>
              <div className="input-holder left">
                <p className="label">{titleCase(value[0])}</p>

                {value[0] === 'securities' ? (
                  <div
                    className="input-1 flex justify-content-center"
                    style={{
                      background: '#0e4646',
                      color: 'white',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setFlagForSecutities(true);
                      setSecurites(JSON.parse(value[1]));
                    }}
                  >
                    View Securities
                  </div>
                ) : value[0] === 'txn_charges' ? (
                  <div
                    className="input-1 flex justify-content-center"
                    style={{
                      background: '#0e4646',
                      color: 'white',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setTaxModal(true);
                      setTotalTax(JSON.parse(value[1]));
                    }}
                  >
                    View Txn Charges
                  </div>
                ) : (
                  // <AiFillEye className="m-3"/>	
                  <div className="input-1">
                    <p
                      style={{
                        fontSize: '15px',
                      }}
                    >
                      {value[1] &&
                        value[1].toString().includes('Pakistan Standard')
                        ? moment(value[1].toString()).format(
                          'DD-MM-YYYY h:mm a'
                        )
                        : value[1] && value[1].toString()}
                    </p>
                  </div>
                )}
              </div>
            </Col>
          ) : (
            ''
          )}
        </>
      );
    });
  };

  // render Model for adding Fund	
  const [disableAddBtn, setDisableAddBtn] = useState<boolean>(false);


  const [note, setNote] = useState('');
  const [viewChecklist, setViewCheckList] = useState(false);
  const [trx_checklist, setTrxCheckList] = useState([]);
  const [templateDD, setTemplateDD] = useState();
  const viewCheckListPopup = () => {
    switch (viewChecklist) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="xl"
          >

            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setViewCheckList(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">Approval Check List </h6>
            </div>
            <div className="modal-body">
              <div className="">
                <div className={'checlist-scroll'}>
                  {trx_checklist.map((val: any, ind: any) => {
                    return (
                      <Row key={ind} className="pt-3">

                        <Col md="5">
                          <text className="text-primary">{val.serial_no}. </text> <text>{val.message}</text>
                        </Col>
                        <Col md="7">
                          <Row>
                            <Col md="3">

                              <FormGroup check>
                                <Label check>
                                  <Input
                                    checked={val.value == 'compliant'}
                                    type="checkbox"
                                    value="compliant"
                                    readOnly />
                                  <span className="form-check-sign" />
                                  Compliant
                                </Label>
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup check>
                                <Label check>
                                  <Input type="checkbox"
                                    checked={val.value == 'na'}
                                    value="na"
                                    readOnly />
                                  <span className="form-check-sign" />
                                  N /A
                                </Label>
                              </FormGroup>
                            </Col>
                            <Col md="7">
                              <FormGroup>
                                <input
                                  type="text"
                                  placeholder="Comments"
                                  value={val.comment}
                                  className="form-control"
                                  readOnly
                                />
                              </FormGroup>

                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                </div>
                {note !== '' && (
                  <Row>
                    <Col md="12">

                      <div className="form-group">
                        <label>Reason of Reject</label>
                        <textarea
                          placeholder="Reason"
                          className={'form-control w-100'}
                          value={note}
                          readOnly
                        ></textarea>
                      </div>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col>
                    <div className=" ">
                      <button
                        className="btn btn-default"
                        onClick={() => {
                          setViewCheckList(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal>
        );
      default:
        return '';
    }
  };

  const [reverseTransactionModal, setReverseTransactionModal] = useState(false);
  const [checkBoxLoading, setCheckBoxLoading] = useState(false);
  const [reverseTransaction, setReverseTransaction] = useState<any>({});

  const viewReverseTransaction = () => {
    switch (reverseTransactionModal) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="xl"
          >

            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setReverseTransactionModal(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">Reverse ({reverseTransaction.txnr_type
                ? CapTxnType(reverseTransaction.txnr_type)
                : 'N/A'}) Transaction </h6>
            </div>
            <div className="modal-body">
              <div className="">
                <Row>
                  <Col>
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox"
                          checked={checkBoxLoading}
                          onChange={() => {
                            setCheckBoxLoading(!checkBoxLoading)
                          }} />
                        <span className="form-check-sign" />
                        <span style={{ color: '#EED202', fontSize: '16px' }}>Warning!!! are you want to reverse this transaction </span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md='3'>
                    <div className=" ">
                      <button
                        className="btn btn-primary d-inline"
                        onClick={() => {
                          setReverseTransactionModal(false);
                        }}
                        disabled={!checkBoxLoading}
                      >
                        Reverse Transaction
                      </button>
                    </div>
                  </Col>
                  <Col md='3'>
                    <div className=" ">
                      <button
                        className="btn btn-default"
                        onClick={() => {
                          setReverseTransactionModal(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal>
        );
      default:
        return '';
    }
  };

  let letterState = [];


  const [displayLetterCheck, setDisplayLetterCheck] = useState(false);
  const renderModalForLetterPopup = () => {
    switch (displayLetterCheck) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            onHide={() => { setDisplayLetterCheck(false) }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setDisplayLetterCheck(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">  Select Template</h6>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Select</label>
                    <ReactTooltip textColor='white' backgroundColor='Black' effect="float" />
                    <select className="form-control"
                      onChange={(e) => {
                        // eslint-disable-next-line  
                        e.nativeEvent.target === null ? '' : e.nativeEvent.target[e.target.selectedIndex].text;
                        setChooseTemplate(e.target.value);
                        setLetterTempates(true);
                        setResetPaymentType(true);
                      }}
                    >
                      <option value="" defaultChecked hidden>{tempLoading ? 'No Template Found' : 'Select Letter Template'}</option>
                      {transType !== 'debtmarketinvestment' && transMode.trim().toLowerCase() === 'RTGS'.toLowerCase() && paymentType.trim().toLowerCase() === 'Receipt'.toLowerCase() && (<option value="TransferInRTGS">RTGS Inflow </option>)}
                      {transType !== 'debtmarketinvestment' && transMode.trim().toLowerCase() === 'RTGS'.toLowerCase() && (paymentType.trim().toLowerCase() === 'Payment or Receipt'.toLowerCase()) && (<option value="ReceivedRTGS">RTGS Inflow Fund Transfer</option>)}

                      {/* {transType !== 'debtmarketinvestment' && transMode === 'RTGS' &&  (paymentType === 'Receipt' || paymentType === 'Payment or Receipt' ) &&   (<option value="ReceivedRTGS">RTGS Inflow</option>) } */}
                      {transType !== 'debtmarketinvestment' && transMode.trim().toLowerCase() === 'RTGS'.toLowerCase() && (paymentType.trim().toLowerCase() === 'Payment'.toLowerCase() || paymentType.trim().toLowerCase() === 'Payment or Receipt'.toLowerCase()) && (<option value="TransferRTGS"> RTGS Outflow</option>)}
                      {/* Pay order / Demand draft Letter */}
                      {transType !== 'debtmarketinvestment' && transMode.trim().toLowerCase() === 'PO/DD'.toLowerCase() && (paymentType.trim().toLowerCase() === 'Payment'.toLowerCase()) && (<option value="demandDraft"> Demand Draft</option>)}

                      {transType !== 'debtmarketinvestment' && transMode.trim().toLowerCase() === 'Online'.toLowerCase() && (paymentType.trim().toLowerCase() === 'Payment'.toLowerCase() || paymentType.trim().toLowerCase() === 'Payment or Receipt'.toLowerCase()) && (<option value="OnlineTransferFund"> Online Transfer of Fund</option>)}

                      {transType === 'debtmarketinvestment' && mmType.trim().toLowerCase() === 'Buy'.toLowerCase() && (<option value="MMPurchase"> Money Market Purchase</option>)}
                      {transType === 'debtmarketinvestment' && mmType.trim().toLowerCase() === 'Sell'.toLowerCase() && (<option value="MMSale"> Money Market Sale</option>)}
                      {transType === 'debtmarketinvestment' && mmType.trim().toLowerCase() === 'Maturity'.toLowerCase() && (<option value="MMMaturitySecurity"> Money Market Maturity of Security</option>)}
                      {transType === 'debtmarketinvestment' && mmType.trim().toLowerCase() === 'Coupon'.toLowerCase() && (<option value="MMMaturityCoupon"> Money Market Maturity of Coupon</option>)}

                    </select>
                    {/* <input type="text" name="" value={transType }/> 
                  <input type="text" name="" value={mmType }/> 
                  <input type="text" name="" value={transMode}/>
                  <input type="text" name="" value={paymentType}/>   */}
                  </div>
                </div>

                <div className="col-md-12 ">
                  {showTemplates === true && chooseTemplate === 'TransferInRTGS' && (
                    <div className="a4-page-letter saleLetter_height" id={'letterview'} ref={canvasRefs}>
                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(transferInFundRTGS) }} />

                    </div>
                  )}

                  {showTemplates === true && chooseTemplate === 'ReceivedRTGS' && (
                    <div className="a4-page-letter saleLetter_height" id={'letterview'} ref={canvasRefs}>
                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(receivedFundRTGS) }} />
                    </div>
                  )}
                  {showTemplates === true && chooseTemplate === 'TransferRTGS' && (
                    <div className="a4-page-letter-largeData" id={'letterview'} ref={canvasRefs}>

                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(transferFundRTGS) }} />
                    </div>
                  )}
                  {showTemplates === true && chooseTemplate === 'demandDraft' && (
                    <div className="a4-page-letter-largeData" id={'letterview'} ref={canvasRefs}>
                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(demand_draft) }} />
                    </div>
                  )}
                  {showTemplates === true && chooseTemplate === 'OnlineTransferFund' && (
                    <div className="a4-page-letter saleLetter_height" id={'letterview'} ref={canvasRefs}>
                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(onlineFT) }} />
                    </div>
                  )}
                  {/* <PDFExport paperSize="A4" pageTemplate={LetterFooter} margin={'1.5cm'} scale={0.8} repeatHeaders={true} fileName={`Letter ${data.txn_id} ${data.amc_code} ${data.execution_date}.pdf`} ref={pdfExportComponent}>
                <div className="a4-page-letter saleLetter" id={'letterview'} ref={canvasRefs}>
                <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(onlineFT) }} />
               
              </div>
              
                </PDFExport> */}
                  {showTemplates === true && chooseTemplate === 'MMSale' && (
                    <div className="a4-page-letter-largeData saleLetter" id={'letterview'} ref={canvasRefs}>
                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mmSale) }} />
                    </div>
                  )}
                  {showTemplates === true && chooseTemplate === 'MMPurchase' && (
                    <div className="a4-page-letter-largeData saleLetter" id={'letterview'} ref={canvasRefs}>
                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mmPurchase) }} />
                    </div>
                  )}
                  {showTemplates === true && chooseTemplate === 'MMMaturitySecurity' && (
                    <div className="a4-page-letter" id={'letterview'} ref={canvasRefs}>
                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mmMaturitySecurity) }} />
                    </div>
                  )}
                  {showTemplates === true && chooseTemplate === 'MMMaturityCoupon' && (
                    <div className="a4-page-letter" id={'letterview'} ref={canvasRefs}>
                      <div className="p-letter" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mmMaturityCoupon) }} />
                    </div>
                  )}
                </div>
                <div className="col-md-12 mt-3">
                  <button className="btn btn-primary btn-block" onClick={() => {
                    printContentLetterFormat();

                  }} disabled={Boolean(disableAddBtn)}>
                    {disableAddBtn ? <><span className="spinner-border login-txt spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span className="login-txt"> Loading...</span></> : <span>Print</span>}
                  </button>
                </div>

              </div>


            </div>
          </Modal>
        );
      default:
        return '';
    }
  };
  const canvasRefs = useRef(null);

  // setObj for letter Printing	
  // const printLetter = () => {	
  //   let tempData = [...selectedTemplate];	
  //   let txn_name = CapTxnType(data.txnr_type);	
  //   let dateValue = new Date();	
  //   tempData[0].label = data.instrument_date || '';	
  //   tempData[1].value = `${data.bank} / ${data.branch} / 2021`;	
  //   tempData[3].value = data.bank;	
  //   tempData[4].value = data.branch;	
  //   tempData[5].value = data.branch;	
  //   tempData[8].value = data.account_title;	
  //   tempData[9].value = data.account_number;	
  //   tempData[10].value = data.broker;	
  //   tempData[11].value = data.mode_of_payment;	
  //   tempData[12].value = data.net_amount; // settlement Amount	
  //   tempData[14].value = data.instrument_type;	
  //   tempData[15].value = data.issue_date;	
  //   tempData[16].value = data.maturity_date;	
  //   tempData[17].value = data.face_value;	
  //   tempData[18].value = data.coupon_rate;	
  //   tempData[20].value = data.counter_bank;	
  //   tempData[21].value = data.counter_bank;	
  //   tempData[22].value = data.counter_bank;	
  //   tempData[23].label = 'Text Should Be here';	
  //   tempData[24].value = data.net_amount;	
  //   tempData[27].value = data.amc_name;	
  //   tempData[29].value = data.nav;	
  //   tempData[30].value = data.gross_amount;	
  //   tempData[31].value = data.net_amount;	
  //   tempData[32].value = data.folio_no;	
  //   tempData[33].value = data.units;	
  //   tempData[34].value = data.sale_date;	
  //   sessionStorage.setItem('letterTemplate', JSON.stringify(tempData));	
  //   history.replace('/admin/print-letter-screen/pending');	
  // };	


  const numberWithCommas = (amount: any) => {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const [disableSendBtn, setdisableSendBtn] = useState(false);
  const [tempValue, setTempValue] = useState('');
  const [fund_account, setFund_account] = useState('');
  const [txnData, setTxnData] = useState('');

  let transferInFundRTGS = transferInFundRTGSEmailTemplate(data, transType, amtWords, transNetAmount, transGrossAmount, grossAmtWords);

  let receivedFundRTGS = ReceiveOfFundRTGSEmailTemplate(data, transType, amtWords, transNetAmount, transGrossAmount, grossAmtWords);
  let onlineFT = OnlineTransferOfFundLetter(data, amtWords, transMode, transType, transNetAmount, transGrossAmount);

  let transferFundRTGS = TransferOfFundRTGSEmailTemplate(data, amtWords, transNetAmount, transGrossAmount);
  //  demand draft letter
  let demand_draft = demandDraftLetterTemplate(data, amtWords, transType, transNetAmount, transGrossAmount, grossAmtWords);

  let mmPurchase = MoneyMarketPurchaseLetter(data, securityData, amtWords, transNetAmount, transGrossAmount);
  let equity = equityInvestmentLetter(data, securityData, transType);
  let mmMaturitySecurity = mmMaturityOfSecurityLetter(data, securityData, transType, amtWords, transNetAmount, transGrossAmount);
  let mmMaturityCoupon = mmMaturityOfCouponLetter(data, securityData, amtWords, transNetAmount, transGrossAmount);
  let mmSale = MoneyMarketSaleLetter(data, securityData, amtWords, transNetAmount, transGrossAmount);

  const [showTemplates, setLetterTempates] = useState(false);
  const [resetPaymentType, setResetPaymentType] = useState(false);

  const printContentLetterFormat = () => {
    try {

      var doc = new jsPDF('p', 'pt', [595.275, 841.89], true);
      let pageHeight = doc.internal.pageSize.getHeight();

      doc.html(document.getElementById('letterview') as HTMLElement, {
        callback: function (doc) {
          let totalPages = doc.internal.pages.length - 1;
          for (let i = 1; i <= totalPages; i++) {
            doc.setFontSize(9);
            // pdf.setTextColor(150)
            doc.text(`______________________________________________________________________________________________________`, doc.internal.pageSize.getWidth() - 550, doc.internal.pageSize.getHeight() - 55);
            doc.text(`Operations Office: Perdesi House | Old Queens Road | Karachi-74200 | Pakistan`, doc.internal.pageSize.getWidth() - 460, doc.internal.pageSize.getHeight() - 40);
            doc.text(`+92 21 32419770  |  www.digitalcustodian.co  |  info@digitalcustodian.co`, doc.internal.pageSize.getWidth() - 440, doc.internal.pageSize.getHeight() - 30);

          }
          doc.save(`Letter ${data.txn_id} ${data.amc_code} ${data.execution_date}.pdf`);
        },
        html2canvas: {
          useCORS: true,
          scale: 0.94
          // width: 500
        },
        margin: [20, 0, 0, 0],
        x: 0,
        y: 0,
      });

    } catch (error: any) {
    }

  }

  const SendMail = async () => {
    if (tempValue !== '') {
      setdisableSendBtn(true);
      try {
        const response = await SendMailTo(email, tempValue, fund_account, txnData);
        toast.success(response.data.message);
        setTxnData('');
        setFund_account('');
        setTempValue('');
        setdisableSendBtn(false);
        setMailModelBoolean(false);
      } catch (error: any) {
        toast.error(error.response.data.message);
      }
    } else {
      toast.info('First Select Template');
    }
    setdisableSendBtn(false);
  };

  const renderMailPopup = () => {
    switch (mailModelBoolean) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal60w"
            show={true}
          >

            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setMailModelBoolean(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up"> Select Template </h6>
            </div>

            <div className="modal-body">
              <Row>
                <div className="col-md-12">
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setTempValue(e.target.value);
                      }}
                    >
                      <option value="" defaultChecked hidden>
                        {mailTempLoading
                          ? 'No Template Found'
                          : 'Select Template'}
                      </option>
                      {renderMailTemplateDropdown()}
                    </select>
                  </div>
                </div>
                <div className="col-md-12">
                  <button
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      SendMail();
                    }}
                    disabled={Boolean(disableSendBtn)}
                  >
                    {disableSendBtn ? (
                      <>
                        <span
                          className="spinner-border login-txt spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span className="login-txt"> Loading...</span>
                      </>
                    ) : (
                      <span>Send</span>
                    )}
                  </button>
                </div>
              </Row>
            </div>
          </Modal>
        );
      default:
        return '';
    }
  };

  let txnr_id: any;
  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              {!view ? (
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Transactions</h4>
                  </div>
                  <div className="card-body">
                    <div className="">
                      {/* <div className="d-flex inline-box">	 */}
                      <Row>
                        <Col md="2">
                          <div className="form-group">
                            <ReactTooltip
                              textColor="white"
                              backgroundColor="black"
                              effect="float"
                            />
                            <label>Transaction ID</label>
                            <input
                              type="search"
                              id="myInput"
                              placeholder="Transaction Id"
                              data-tip="Search Transaction"
                              className="form-control"
                              value={searchValue}
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                              }}
                              onKeyPress={(e) => {
                                let key_board_keycode = e.which || e.keyCode;
                                if (key_board_keycode == 13) {
                                  e.preventDefault();
                                  if ((searchValue || status !== "-1" || Amc || fund) !== '') {
                                    searchTransactionsByAMCAndFund(status, searchValue, Amc, fund).then(() => {
                                      // setPaginationArr(['']);
                                      setActivePage('');

                                    });
                                  }
                                }
                              }}
                            />
                          </div>
                        </Col>

                        <Col md="2">
                          <div className="form-group ml-2 mr-2">
                            <label >Select AMC</label>
                            <select
                              className={"form-control"}
                              value={Amc}
                              onChange={(e) => {
                                setAmc(e.target.value);
                                getFunds(e.target.value);
                              }}
                            >
                              <option value="" defaultChecked hidden>
                                Select AMC
                              </option>
                              {renderAmcDropdown()}
                            </select>
                          </div>
                        </Col>

                        <Col md="2">
                          <div className="form-group ml-2 mr-2">
                            <label >Select Fund</label>
                            <select
                              className={"form-control"}
                              value={fund}
                              onChange={(e) => {
                                setFund(e.target.value);
                              }}>
                              <option value="" defaultChecked hidden>
                                Select Fund
                              </option>
                              {renderFundsDropDown()}
                            </select>
                          </div>
                        </Col>

                        <Col md="2">
                          {/* <div className=" inline-box">	 */}
                          <div className="form-group ml-2 mr-2">
                            <label >Select Status</label>
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setStatus(e.target.value);
                              }}
                              value={status}
                            >
                              <option value="-1">Select type</option>
                              <option value="COMPLIANCE">Compliance</option>
                              <option value="INREVIEW">In Review</option>
                              <option value="SIGNATORY-A">Signatory A</option>
                              <option value="SIGNATORY-B">Signatory B</option>
                              <option value="COMPLETED">Completed</option>
                              <option value="CONCERNED-OFFICER">CONCERNED OFFICER</option>
                              <option value="REJECTED-TRUSTEE">Rejected TRUSTEE</option>
                              <option value="REJECTED-AMC">Rejected AMC</option>
                            </select>
                          </div>

                        </Col>


                        <Col md="4">
                          <div className=" inline-box">
                            <button
                              className="btn btn-primary mt-4"
                              disabled={Boolean(searchLoading)}
                              onClick={() => {
                                if ((searchValue || status !== "-1" || Amc || fund) !== '') {
                                  searchTransactionsByAMCAndFund(status, searchValue, Amc, fund).then(() => {
                                    // setPaginationArr(['']);
                                    setActivePage('');

                                  });
                                }
                              }}
                            >
                              {searchLoading ? (
                                <>
                                  <span
                                    className="spinner-border login-txt spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span className="login-txt"> Searching...</span>
                                </>
                              ) : (
                                'Search'
                              )}
                            </button>
                            <button
                              className="btn btn-default mt-4"
                              disabled={Boolean(clearLoading)}
                              onClick={() => {
                                setSearchValue('');
                                clearFilters('', '').then(() => {
                                  setStatus('-1');
                                  setSearchValue('');
                                  setActivePage('');
                                  setAmc('');
                                  setFund('');
                                });
                              }}
                            >
                              {clearLoading ? (
                                <>
                                  <span
                                    className="spinner-border login-txt spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span className="login-txt"> Clear</span>
                                </>
                              ) : (
                                'Clear'
                              )}
                            </button>
                          </div>
                        </Col>
                        {/* </div>	 */}

                      </Row>
                      {/* </div>	 */}
                    </div>


                    <div className="">
                      {resLoading ? (
                        <div className="d-flex justify-content-center my-5">
                          <i className="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i>
                        </div>
                      ) : (
                        transactions.length > 0 ? (
                          <div className='table-responsive'>
                            <table className="table mt-2 ">
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Transaction</th>
                                  <th>Fund</th>
                                  <th className='text-right'>Amount</th>
                                  <th>Bank</th>
                                  <th>Counter Acc</th>
                                  <th>Instrument</th>
                                  <th>Created</th>
                                  <th>Status</th>
                                  <th>Act</th>
                                </tr>
                              </thead>
                              <tbody>
                                {transactions.map((transaction: any, index: number) => {
                                  return (
                                    // <tr style={customStyle(transaction.txn_status)}  key={index}>
                                    // <tr key={index} className={(transaction.txnr_type
                                    //   ? CapTxnType(transaction.txnr_type)
                                    //   : 'N/A' )==='Equity Auto-Settlement'? "highlight-row-error": '' }>
                                    <tr key={index}>
                                      <td>{moment(transaction.instruction_date).format('DD-MM-YYYY')} <br />
                                        <span className="sub-content">Exe: {moment(transaction.execution_date).format('DD-MM-YYYY')}</span>
                                      </td>

                                      <td>{transaction.txnr_type
                                        ? CapTxnType(transaction.txnr_type)
                                        : 'N/A'}<br /> <span className="sub-content">{transaction.txn_id.replace('TXN_', '')}</span></td>

                                      <td>{transaction.fund_code}	<br />
                                        <span className="sub-content">{transaction.amc_code
                                          ? transaction.amc_code
                                          : 'N/A'}	</span>
                                      </td>

                                      <td className="text-right pr-3">{numberWithCommas(transaction.net_amount)} <br />
                                        <span className="sub-content">{numberWithCommas(transaction.gross_amount)}</span>
                                      </td>

                                      <td>{transaction.bank}<br />
                                        <span className="sub-content">{transaction.account_number}</span></td>

                                      <td>{transaction.counter_bank} <br />
                                        <span className="sub-content">{transaction.counter_account_number}</span></td>

                                      <td>{transaction.mode_of_payment} <br />
                                        <span className="sub-content">{transaction.instrument_type} {transaction.instrument_no !== '' ? transaction.instrument_no + ',' : ''} {transaction.instrument_date !== '' ? moment(transaction.instrument_date).format('DD-MM-YYYY') : ''}</span></td>

                                      <td>{moment(transaction.created_at).format('DD-MM-YYYY')} <br />
                                        {/* <span className="sub-content">{transaction.created_by	
                                ? transaction.created_by	
                                : 'N/A'}</span>	 */}
                                        <span className="sub-content">{transaction.created_by.split('@')[0]}</span>
                                      </td>
                                      <td>{transaction.txn_status}</td>
                                      <td className=" ">


                                        <div className="multi-icons pointer">
                                          {/* <button type="button" className="btn-icon btn-link like btn btn-primary btn-sm  mt-minus6" onClick={() => {
                                            history.push(`/admin/verify-transaction/${txnr_id= transaction.txn_id.replace('TXN_','')}`);

                                          }}  >
                                            <i className="fa fa"></i>
                                          </button> */}
                                          <button type="button" className="btn-icon btn-link like btn btn-primary btn-sm  mt-minus6" onClick={() => {
                                            // setData(transaction);
                                            let txnData = transaction;
                                            let bankname = bankName(transaction.bank.toString())
                                            let counterbankname = bankName(transaction.counter_bank.toString())
                                            setData({
                                              ...txnData,
                                              bank: bankname,
                                              counter_bank: counterbankname
                                            });
                                            sessionStorage.setItem("view_txn_from", "transaction-status")

                                            setView(true);
                                            setTrxHistory(transaction.txn_history);
                                          }}  >
                                            <i className="fa fa-eye"> </i>
                                          </button>

                                          {
                                            transaction.txnr_type !== 'transferofunits' && (
                                              <>
                                                {
                                                  ((transaction.mode_of_payment === "Cheque" || transaction.mode_of_payment === "Online" || transaction.mode_of_payment === "RTGS" || transaction.mode_of_payment === "IFT" || transaction.mode_of_payment === "IBFT")
                                                    && (transaction.txn_status === "COMPLETED") && (transaction.amc_code === "MCBAH")) && (
                                                    <>
                                                      <ExcelFile element={
                                                        <button type="button" data-tip={'Download Excel file'} style={{ border: "none" }} className="btn-icon btn-link like btn btn-primary btn-sm  mt-minus6"
                                                        ><i className="fa fa-download"></i></button>
                                                      } filename="IFT/IBFT Excel Report">
                                                        <ExcelSheet data={[transaction]} name="Sheet1">
                                                          <ExcelColumn label="P&C ID" value="" />
                                                          <ExcelColumn label="REFERENCE ID" value="" />
                                                          <ExcelColumn label="FUND NAME" value="fund_code" />
                                                          <ExcelColumn label="FUND BANK" value="bank" />
                                                          <ExcelColumn label="FUND BANK BRANCH" value="branch" />
                                                          <ExcelColumn label="FUND BRANCH CITY" value="" />
                                                          <ExcelColumn label="FUND A/C TITLE" value="account_title" />
                                                          <ExcelColumn label="REQUESTED PAYMENT DATE" value="created_at" />
                                                          <ExcelColumn label="ACTUAL PAYMENT DATE" value="settlement_date" />
                                                          <ExcelColumn label="TRANSACTION TYPE" value="txnr_type" />
                                                          <ExcelColumn label="BENEFICIARY ID / SHORT_NAME" value="" />
                                                          <ExcelColumn label="BENEFICIARY BANK A/C TITLE" value="counter_account_title" />
                                                          <ExcelColumn label="BENEFICIARY BANK A/C #" value="counter_account_number" />
                                                          <ExcelColumn label="BENEFICIARY BANK NAME" value="counter_bank" />
                                                          <ExcelColumn label="BENEFICIARY BRANCH NAME & CITY" value="counter_branch" />
                                                          <ExcelColumn label="INSTRUMENT TYPE" value="instrument_type" />
                                                          <ExcelColumn label="PRINTING LOCATION" value="" />
                                                          <ExcelColumn label="CLEARING ZONE" value="" />
                                                          <ExcelColumn label="INSTRUMENT NO" value="instrument_no" />
                                                          <ExcelColumn label="AMOUNT PAYABLE" value="" />
                                                          <ExcelColumn label="ACTUAL PAID" value="net_amount" />
                                                          <ExcelColumn label="PENDING NOT PAID" value="" />
                                                          <ExcelColumn label="PAYMENT MODE" value="mode_of_payment" />
                                                          <ExcelColumn label="P&C STATUS" value="" />
                                                          <ExcelColumn label="REMARKS" value="" />
                                                        </ExcelSheet>
                                                      </ExcelFile>
                                                    </>
                                                  )
                                                }

                                                {/* {transaction.txn_status === 'COMPLETED' && transaction.txnr_type!=='equityinvestment' && (   */}
                                                {transaction.txn_status === 'COMPLETED' &&
                                                  (
                                                    // case 1
                                                    ((transaction.mode_of_payment.toUpperCase() !== 'CHEQUE' &&
                                                      transaction.instrument_type.toUpperCase() !== 'CHEQUE' && transaction.mode_of_payment.toUpperCase() !== 'PO/DD') || (transaction.mode_of_payment.toUpperCase() === 'PO/DD') && (transaction.payment_type.toUpperCase() !== 'RECEIPT')) ||
                                                    // case 2
                                                    ((transaction.mode_of_payment.toUpperCase() === 'ONLINE') && (transaction.payment_type.toUpperCase() !== 'RECEIPT')) ||
                                                    // case 3
                                                    (transaction.mode_of_payment.toUpperCase() === 'RTGS')

                                                  ) &&
                                                  (
                                                    <>
                                                      <ReactTooltip
                                                        textColor="white"
                                                        backgroundColor="black"
                                                        effect="float"
                                                      />
                                                      <button type="button" data-tip={'Print Letter'} className="btn-icon btn-link like btn btn-primary btn-sm  mt-minus6"
                                                        onClick={async () => {
                                                          let txnData = transaction;
                                                          // if (txnData.mode_of_payment = "PO/DD") {
                                                          //   try {
                                                          //     const response = await getLedger(email, txnData.txn_id.replace('TXN_', ''));
                                                          //     setLedgerData(response.data.data.filter(item=>item['Record'].credit_amount>=0));
                                                          //     // })
                                                          //   } catch (error: any) {
                                                          //     if (error.response !== undefined) {
                                                          //       toast.error(error.response.data.message)
                                                          //     }
                                                          //   }
                                                          // }
                                                          let bankname = bankName(transaction.bank.toString())
                                                          let counterbankname = bankName(transaction.counter_bank.toString())
                                                          getLetterTemplateCall(transaction.bank);
                                                          setData({
                                                            ...txnData,
                                                            bank: bankname,
                                                            counter_bank: counterbankname
                                                          });
                                                          if (transaction.securities === "") {
                                                            transaction.securities = "[]";
                                                          }

                                                          let securities = JSON.parse(transaction.securities);
                                                          setSecurityData(securities);

                                                          setMMType(securities.filter(u => u.type === 'Maturity' || u.type === 'Buy' || u.type === 'Sell' || u.type === 'Coupon').map(e => e.type)[0]);
                                                          setTransType(transaction.txnr_type);
                                                          setTransMode(transaction.mode_of_payment);
                                                          setPaymentType(transaction.payment_type);
                                                          // Net Amount
                                                          transaction.net_amount = transaction.net_amount.replace(",", "");
                                                          // let amount= transaction.net_amount.split('.'); 
                                                          setAmtWords(inWords(parseFloat(transaction.net_amount).toFixed(2)));

                                                          setTransNetAmount(isNumber(parseFloat(transaction.net_amount).toFixed(2)));

                                                          // Gross Amount
                                                          transaction.gross_amount = transaction.gross_amount.replace(",", "");
                                                          // let grossAmount= transaction.gross_amount.split('.'); 
                                                          setGrossAmtWords(inWords(parseFloat(transaction.gross_amount).toFixed(2)));
                                                          setTransGrossAmount(isNumber(parseFloat(transaction.gross_amount).toFixed(2)));

                                                          setDisplayLetterCheck(true);
                                                          setLetterTempates(false);
                                                          setResetPaymentType(false)
                                                        }}
                                                      >
                                                        <i className="fa fa-envelope-open-text"></i>
                                                      </button>

                                                      <button type="button" data-tip={'Send Mail'} className="btn-icon btn-link like btn btn-primary btn-sm  mt-minus6"
                                                        onClick={() => {
                                                          setTxnData(JSON.stringify(transaction));
                                                          setFund_account(
                                                            transaction.fund_account
                                                          );
                                                          setMailModelBoolean(true);
                                                        }}
                                                      >
                                                        <i className="fa fa-envelope fa-4x"></i>
                                                      </button>
                                                    </>
                                                  )}
                                              </>
                                            )
                                          }
                                          {/* {transaction.txn_status === "COMPLETED" && (
                                            <button type="button" data-tip={'Reverse Transaction'} className="btn-icon btn-link like btn btn-primary btn-sm  mt-minus6"
                                              onClick={() => {
                                                setReverseTransactionModal(true)
                                                setReverseTransaction(transaction)
                                              }}
                                            >
                                              <i className="fa fa-backward"></i>
                                            </button>
                                          )} */}
                                        </div>


                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="table-empty">
                            <BsTable className="icon" />
                            <p className="text-center empty-text">No record found</p>
                          </div>
                        )
                      )}

                      {/* {togglePagination===true ? ( */}
                      <div
                        className="row pointer mr-3"
                        style={{
                          float: 'right',
                        }}

                      >
                        {/* PREVIOUS BUTTON */}
                        {activePage !== paginationArr[0] ? (
                          <i
                            className="fa fa-arrow-left"
                            aria-hidden="true"
                            onClick={() => {
                              let pageArr = paginationArr;
                              let index = pageArr.findIndex((x) => x === activePage);
                              if (index !== -1) {
                                setActivePage(paginationArr[index - 1]);
                              }
                            }}
                          ></i>
                        ) : (
                          ''
                        )}
                        {/* NEXT BUTTON */}
                        {activePage !== paginationArr[paginationArr.length - 1] ? (
                          <i
                            className="fa ml-3 fa-arrow-right"
                            aria-hidden="true"
                            onClick={() => {
                              let pageArr = paginationArr;
                              let index = pageArr.findIndex((x) => x === activePage);
                              if (index !== -1) {
                                setActivePage(paginationArr[index + 1]);
                              }
                            }}
                          ></i>
                        ) : (
                          ''
                        )}
                      </div>
                      {/* ):(
                   ''
                  )} */}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="">

                  <h4>
                    <span>
                      <i className="fa fa-angle-left mr-2 mt-1 pointer" onClick={() => {
                        setView(false);
                        setColor('#db6cfa');
                      }}></i>
                      View Transaction
                    </span>
                    <span>
                      <Link to='/admin/transaction-status' >
                        <IoMdClose size={35} className='ml-2 mt-1 pointer float-right'
                          style={styles}
                          onMouseEnter={() => setColor("white")}
                          onMouseLeave={() => setColor("#db6cfa")}
                          onClick={() => {
                            setView(false);
                            setColor('#db6cfa');
                          }}
                        />
                      </Link>
                    </span>
                  </h4>
                  {/* <h4 className='float-right'>
                    
                  </h4> */}
                  <ViewTransaction data={data} />

                  <div className="line"></div>

                  <Row>
                    {trx_history.map((hist: any, index: number) => {
                      return (
                        <Col
                          md="3"
                          onClick={() => {
                            if (hist.action === 'REJECTED-TRUSTEE' || hist.action === 'REJECTED-AMC') {
                              setNote(hist.note);
                            } else {
                              setNote('');
                            }
                            if (hist.action === 'CREATED') {
                              return;
                            }
                            if (!hist.check_list) return;
                            setTrxCheckList(hist.check_list);
                            setViewCheckList(true);
                          }}
                        >
                          <div className="card process-card pointer">
                            <div className="card-header">
                              <h4 className="card-title">
                                <span className="card-number">
                                  {index + 1}
                                </span>
                                <span className="mr-1">
                                </span> <i className="tim-icons icon-single-02 mr-1"></i> 	 {hist.updated_by_role}
                              </h4>
                            </div>
                            <div className="card-body text-center">

                              <p className="small mt-2">Status:</p>
                              <h3 className="accepted text-primary">  {hist.action}    </h3>
                              {hist.updated_at !== '' ? (
                                <>
                                  <p className="small mt-2"> by</p>
                                  <h4 className="comment text-primary">{(hist.updated_by)}</h4>
                                  <p className="small mt-2">at</p>
                                  <h4 className="comment text-primary">{moment(hist.updated_at).format("DD-MM-YYYY, h:mm a")}</h4>
                                </>
                              ) : (
                                ''
                              )}
                              {hist.note !== '' ? (
                                <>
                                  <p className="small mt-2">Comment</p>
                                  <small className="comment dot-text" title={hist.note}>{hist.note}</small>
                                </>
                              ) : (
                                ''
                              )}
                              {
                                hist.created_by !== '' ? (
                                  <>
                                    <p className="small mt-2"> by</p>
                                    <h4 className="text-primary">{hist.created_by}</h4>
                                    <p className="small mt-2"> at</p>
                                    <h4 className="comment text-primary">  {moment(hist.created_at).format("DD-MM-YYYY, h:mm a")}</h4>

                                  </>
                                ) : (
                                  ''
                                )}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              )}
              {renderSecuritiesModalPopup()}
              {renderTaxPopup()}
              {renderModalForLetterPopup()}
              {viewCheckListPopup()}
              {viewReverseTransaction()}
              {renderMailPopup()}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default PendingTransactions;


